import { useState, useEffect } from "react";
import { io } from "socket.io-client";
import { useCart } from "../context/CartContext";

export const socket = io(
  "https://backend-verduleria-production.up.railway.app",
  {
    transports: ["websocket", "polling"],
  }
);

const useFilteredProducts = () => {
  const { state, dispatch } = useCart();

  const [productosOriginales, setProductosOriginales] = useState([]);
  const [isClosed, setIsClosed] = useState("true");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [activeCategory, setActiveCategory] = useState("todos");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchProductos = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        `https://backend-verduleria-production.up.railway.app/api/products`
      );

      let productos = await response.json();
      productos.sort((a, b) => a.nombre.localeCompare(b.nombre));
      localStorage.setItem("productos", JSON.stringify(productos));

      const productosDisponibles = productos.filter(
        (producto) => producto.disponible === true
      );
      if (productosDisponibles.length === 0) {
        setIsClosed(true);
      } else {
        setIsClosed(false);
      }
      setProductosOriginales(productos);
      setFilteredProducts(productos);
    } catch (error) {
      console.error("Error al obtener los productos:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchProductos();
  }, []);

  useEffect(() => {
    socket.on("productoActualizado", (productoActualizado) => {
      let aux = productosOriginales.map((producto) =>
        producto.id === productoActualizado.id ? productoActualizado : producto
      );
      setProductosOriginales(aux);
      setFilteredProducts(aux);
      localStorage.setItem("productos", JSON.stringify(aux));
      if (!productoActualizado.disponible) {
        dispatch({ type: "REMOVE_FROM_CART", payload: productoActualizado });
      } else {
        dispatch({ type: "UPDATE_CART_PRODUCT", payload: productoActualizado });
      }
    });

    socket.on("productoCreado", (nuevoProducto) => {
      setProductosOriginales((prevProductos) => [
        ...prevProductos,
        nuevoProducto,
      ]);
      localStorage.setItem(
        "productos",
        JSON.stringify([...productosOriginales, nuevoProducto])
      );
    });

    socket.on("productoEliminado", (productoId) => {
      setProductosOriginales((prevProductos) =>
        prevProductos.filter((producto) => producto.id !== productoId)
      );

      localStorage.setItem(
        "productos",
        JSON.stringify(
          productosOriginales.filter((producto) => producto.id !== productoId)
        )
      );
    });

    socket.on("productosDeshabilitados", () => {
      dispatch({ type: "REMOVE_CART", payload: [] });
      setIsClosed(true);
      fetchProductos();
    });
    socket.on("productosHabilitados", () => {
      setIsClosed(false);
      fetchProductos();
    });

    return () => {
      socket.off("productoActualizado");
      socket.off("productoCreado");
      socket.off("productoEliminado");
      socket.off("productosDeshabilitados");
      socket.off("productosHabilitados");
    };
  }, [productosOriginales]);

  useEffect(() => {
    const applyFilters = () => {
      const filtered = productosOriginales.filter((producto) => {
        const matchesCategory =
          activeCategory === "todos" || producto.categoria === activeCategory;
        const matchesSearch = producto.nombre
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
        return matchesCategory && matchesSearch;
      });
      setFilteredProducts(filtered);
    };

    applyFilters();
  }, [activeCategory, searchTerm, productosOriginales]);

  return {
    filteredProducts,
    activeCategory,
    setActiveCategory,
    searchTerm,
    setSearchTerm,
    loading,
    isClosed,
    productosOriginales,
  };
};

export default useFilteredProducts;
